export default "__VITE_ASSET__d4d120d2__"